import { createElementBlock as a, openBlock as o, createElementVNode as l } from "vue";
import t from "./index289.js";
const c = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, e, i, f, m, p) {
  return o(), a("svg", n, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF3AB",
        d: "M22.108 32.177c0-4.678 3.914-8.47 8.74-8.47 4.825 0 8.737 3.792 8.737 8.47"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M30.847 22.456c5.508 0 9.988 4.344 9.988 9.721a1.25 1.25 0 1 1-2.5 0c0-3.979-3.344-7.22-7.488-7.22s-7.489 3.242-7.489 7.22a1.25 1.25 0 1 1-2.5 0c0-5.377 4.482-9.72 9.99-9.72Zm0-12.706c.647 0 1.18.492 1.243 1.122l.007.128v4.235a1.25 1.25 0 0 1-2.494.128l-.006-.128V11c0-.69.56-1.25 1.25-1.25ZM13.369 30.927a1.25 1.25 0 0 1 .128 2.494l-.128.006H9a1.25 1.25 0 0 1-.128-2.494L9 30.927h4.369Zm1.288-14.445a1.25 1.25 0 0 1 1.665-.117l.102.09 2.185 2.118a1.25 1.25 0 0 1-1.637 1.885l-.103-.09-2.185-2.118a1.25 1.25 0 0 1-.027-1.768Zm30.613-.027a1.25 1.25 0 0 1 1.833 1.695l-.093.1-2.185 2.118a1.25 1.25 0 0 1-1.832-1.695l.092-.1 2.185-2.118ZM53 30.927a1.25 1.25 0 0 1 .128 2.494l-.128.006h-4.675a1.25 1.25 0 0 1-.127-2.494l.127-.006H53Zm-22.126 4.236h-.027c.091 0 .18.01.267.028l.035.008c.03.008.06.016.09.026l.042.015a1.087 1.087 0 0 1 .237.118 1.233 1.233 0 0 1 .099.07l.011.009.046.038.043.04 4.369 4.235a1.25 1.25 0 0 1-1.637 1.885l-.103-.09-2.25-2.18V47a1.25 1.25 0 0 1-2.493.128L29.597 47v-7.637l-2.25 2.182a1.25 1.25 0 0 1-1.668.065l-.1-.093a1.25 1.25 0 0 1-.065-1.667l.093-.1 4.351-4.217c.036-.036.075-.07.115-.103l-.096.085a1.26 1.26 0 0 1 .22-.17l.01-.006c.032-.02.066-.038.1-.054l.03-.014c.031-.015.065-.028.099-.04.007-.001.013-.004.02-.006.123-.04.254-.063.39-.063h.028Z"
      })
    ], -1)
  ]));
}
const h = /* @__PURE__ */ t(c, [["render", r]]);
export {
  h as default
};
